module.exports = __webpack_public_path__ + "static/media/facebook.2bd58719.svg";